import {createContext} from "react";

/** Coordination between selection commands and GM map tools, independent of rendering effects. */
export const TableTopSelectionEvents = createContext<{
    subscribe: (listener: () => void) => () => void;
} | null>(null);
